/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DocumentForListViewModel } from '../model/documentForListViewModel';
import { GroupedPunchesByRolesViewModel } from '../model/groupedPunchesByRolesViewModel';
import { MasterViewModel } from '../model/masterViewModel';
import { SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel } from '../model/signedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel';
import { SignedPunchesExecuteBody } from '../model/signedPunchesExecuteBody';
import { SignedPunchesExecuteBody1 } from '../model/signedPunchesExecuteBody1';
import { SignedPunchesExecuteBody2 } from '../model/signedPunchesExecuteBody2';
import { SignedPunchesExecuteBody3 } from '../model/signedPunchesExecuteBody3';
import { SignedPunchesSavePunchesPreviewBody } from '../model/signedPunchesSavePunchesPreviewBody';
import { SignedPunchesSavePunchesPreviewBody1 } from '../model/signedPunchesSavePunchesPreviewBody1';
import { SignedPunchesSavePunchesPreviewBody2 } from '../model/signedPunchesSavePunchesPreviewBody2';
import { SignedPunchesSavePunchesPreviewBody3 } from '../model/signedPunchesSavePunchesPreviewBody3';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DocumentProcessorService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param pdfFile 
     * @param documentProcessorTypeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createPreviewForm(pdfFile?: Blob, documentProcessorTypeId?: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public createPreviewForm(pdfFile?: Blob, documentProcessorTypeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public createPreviewForm(pdfFile?: Blob, documentProcessorTypeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public createPreviewForm(pdfFile?: Blob, documentProcessorTypeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (documentProcessorTypeId !== undefined && documentProcessorTypeId !== null) {
            queryParameters = queryParameters.set('documentProcessorTypeId', <any>documentProcessorTypeId);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (pdfFile !== undefined) {
            formParams = formParams.append('pdfFile', <any>pdfFile) as any || formParams;
        }

        return this.httpClient.request<number>('post',`${this.basePath}/v1/DocumentProcessor/CreatePreview`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public discardPreviews(body?: Array<number>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public discardPreviews(body?: Array<number>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public discardPreviews(body?: Array<number>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public discardPreviews(body?: Array<number>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/DocumentProcessor/DiscardPreviews`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param previousProcessId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public executeProcess(body?: SignedPunchesExecuteBody, previousProcessId?: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public executeProcess(body?: SignedPunchesExecuteBody, previousProcessId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public executeProcess(body?: SignedPunchesExecuteBody, previousProcessId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public executeProcess(body?: SignedPunchesExecuteBody, previousProcessId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (previousProcessId !== undefined && previousProcessId !== null) {
            queryParameters = queryParameters.set('previousProcessId', <any>previousProcessId);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/v1/DocumentProcessor/SignedPunches/Execute`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param documentProcessorTypeId 
     * @param previews 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllDocumentsForList(documentProcessorTypeId?: number, previews?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<DocumentForListViewModel>>;
    public getAllDocumentsForList(documentProcessorTypeId?: number, previews?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DocumentForListViewModel>>>;
    public getAllDocumentsForList(documentProcessorTypeId?: number, previews?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DocumentForListViewModel>>>;
    public getAllDocumentsForList(documentProcessorTypeId?: number, previews?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (documentProcessorTypeId !== undefined && documentProcessorTypeId !== null) {
            queryParameters = queryParameters.set('documentProcessorTypeId', <any>documentProcessorTypeId);
        }
        if (previews !== undefined && previews !== null) {
            queryParameters = queryParameters.set('previews', <any>previews);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DocumentForListViewModel>>('get',`${this.basePath}/v1/DocumentProcessor/AllDocumentsForList`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param processId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPunchesBySignRoles(processId?: number, observe?: 'body', reportProgress?: boolean): Observable<GroupedPunchesByRolesViewModel>;
    public getPunchesBySignRoles(processId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GroupedPunchesByRolesViewModel>>;
    public getPunchesBySignRoles(processId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GroupedPunchesByRolesViewModel>>;
    public getPunchesBySignRoles(processId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (processId !== undefined && processId !== null) {
            queryParameters = queryParameters.set('processId', <any>processId);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GroupedPunchesByRolesViewModel>('post',`${this.basePath}/v1/DocumentProcessor/SignedPunches/PunchesBySignRoles`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param processId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSignedPunchesDocumentPreview(processId?: number, observe?: 'body', reportProgress?: boolean): Observable<SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel>;
    public getSignedPunchesDocumentPreview(processId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel>>;
    public getSignedPunchesDocumentPreview(processId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel>>;
    public getSignedPunchesDocumentPreview(processId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (processId !== undefined && processId !== null) {
            queryParameters = queryParameters.set('processId', <any>processId);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SignedPunchesDetailPreviewViewModelDocumentDetailPreviewViewModel>('get',`${this.basePath}/v1/DocumentProcessor/SignedPunches/Preview`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public isSignedPunchesVisible(observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public isSignedPunchesVisible(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public isSignedPunchesVisible(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public isSignedPunchesVisible(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('get',`${this.basePath}/v1/DocumentProcessor/SignedPunches/Visible`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param mediaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pagePreview(body?: Array<number>, mediaId?: number, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public pagePreview(body?: Array<number>, mediaId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public pagePreview(body?: Array<number>, mediaId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public pagePreview(body?: Array<number>, mediaId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (mediaId !== undefined && mediaId !== null) {
            queryParameters = queryParameters.set('mediaId', <any>mediaId);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/v1/DocumentProcessor/PagePreview`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param processId 
     * @param punchIdModified 
     * @param punchCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public savePunchCodeOnSignedPunchesPreview(processId?: number, punchIdModified?: number, punchCode?: string, observe?: 'body', reportProgress?: boolean): Observable<MasterViewModel>;
    public savePunchCodeOnSignedPunchesPreview(processId?: number, punchIdModified?: number, punchCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterViewModel>>;
    public savePunchCodeOnSignedPunchesPreview(processId?: number, punchIdModified?: number, punchCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterViewModel>>;
    public savePunchCodeOnSignedPunchesPreview(processId?: number, punchIdModified?: number, punchCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (processId !== undefined && processId !== null) {
            queryParameters = queryParameters.set('processId', <any>processId);
        }
        if (punchIdModified !== undefined && punchIdModified !== null) {
            queryParameters = queryParameters.set('punchIdModified', <any>punchIdModified);
        }
        if (punchCode !== undefined && punchCode !== null) {
            queryParameters = queryParameters.set('punchCode', <any>punchCode);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MasterViewModel>('put',`${this.basePath}/v1/DocumentProcessor/SignedPunches/SavePunchCodeOnPreview`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param processId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public savePunchesPreview(body?: SignedPunchesSavePunchesPreviewBody, processId?: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public savePunchesPreview(body?: SignedPunchesSavePunchesPreviewBody, processId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public savePunchesPreview(body?: SignedPunchesSavePunchesPreviewBody, processId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public savePunchesPreview(body?: SignedPunchesSavePunchesPreviewBody, processId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (processId !== undefined && processId !== null) {
            queryParameters = queryParameters.set('processId', <any>processId);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/v1/DocumentProcessor/SignedPunches/SavePunchesPreview`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
